<span style="line-height: normal;" *ngIf="mathType?.key===TEXT_TYPES?.TEXT?.key" [innerHTML]="text|sanitizeHtml"></span>
<span *ngIf="mathType?.key===TEXT_TYPES?.MATH?.key">
    <ng-katex style="font-size: 18px;" [equation]="text"></ng-katex>
</span>